import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { InspectionViewController } from 'pages/viewer/inspectionController/InspectionViewController'
import { MultiComponentViewProvider } from 'pages/viewer/MultiComponentViewContext'
import { z } from 'zod'

export const Route = createFileRoute('/viewer/$unitID/inspection')({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      siteID: z.string().optional(),
      mode: z.enum(['2D', '3D']).optional(),
      selectedComponent: z.string().optional(),
      selectedComponentId: z.string().optional(),
      position: z
        .object({
          x: z.number().optional(),
          y: z.number().optional(),
          z: z.number().optional(),
        })
        .optional(),
      rotation: z
        .object({
          x: z.number().optional(),
          y: z.number().optional(),
          z: z.number().optional(),
        })
        .optional(),
    })
  ),
})

function RouteComponent() {
  const { unitID } = Route.useParams()

  return (
    <MultiComponentViewProvider unitID={unitID} viewer={'inspection'}>
      <InspectionViewController />
    </MultiComponentViewProvider>
  )
}
